"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QR_CODE = void 0;
const QR_CODE = exports.QR_CODE = 'qr-code';
